"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateToAge = void 0;
const is_valid_date_1 = require("../../validation/is-valid-date/is-valid-date");
const get_today_date_1 = require("../get-today-date/get-today-date");
/**
 * Get age from birthDate up to current date
 * @public
 *
 * @param birthDate - Date to calculate age
 *
 * @returns The age corresponding to birthDate
 *
 * @example
 * ```ts
 * // todayDate -> '01/01/2021'
 * const age = dateToAge(new Date('01/01/1995'));
 * console.log(age);
 * // -> 26
 * ```
 */
function dateToAge(birthDate) {
    let age = 0;
    if ((0, is_valid_date_1.isValidDate)(birthDate)) {
        const today = (0, get_today_date_1.getTodayDate)();
        const diff = today.getTime() - birthDate.getTime();
        const ageDate = new Date(diff);
        age = Math.abs(ageDate.getUTCFullYear() - 1970);
    }
    return age;
}
exports.dateToAge = dateToAge;
//# sourceMappingURL=date-to-age.js.map